import {Observable} from 'rxjs';

import {GetConfigPayloadDto} from '@features/app-config/application/use_cases/get-config/dto/get-config.payload.dto';
import {GetConfigResponseDto} from '@features/app-config/application/use_cases/get-config/dto/get-config.response.dto';

export abstract class AppConfigPort {

  abstract getConfig(payload: GetConfigPayloadDto): Observable<GetConfigResponseDto>;

}
